/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */

'use strict';
angular
  .module('http.metadataCompare', ['shared.filters'])
  /**
   * Service used to get metadata compare data.
   */
  .factory('httpMetadataCompare', function ($http) {
    /**
     * Get the files for the metadata component.
     *
     * @param {Number} batchId - The batch id of the metadata compare.
     * @param {String} metadataType - The metadata component.
     * @param {Number} [pageNum=1] - The page of results to get.
     * @param {Boolean} [isOnlyDifference=false] - Flag to retrieve fields only that changed or all.
     * @returns {Promise} - A promise that resolves to a metadata compare file objects containing
     * a page of results and a total count.
     */
    var getMetadataCompareFilesByType = function (batchId, metadataType, pageNum, isOnlyDifference) {
      pageNum = pageNum || 1;
      isOnlyDifference = isOnlyDifference || false;

      return $http({
        method: 'GET',
        url: 'api/metadata-compare/results',
        params: {
          batchId: batchId,
          pageNumber: pageNum,
          componentType: metadataType,
          isOnlyDifference: isOnlyDifference
        }
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the diff data from S3
     *
     * @param {String} diffUrl - The URL to the diff in S3
     * @returns {Promise}
     */
    var getMetadataDiff = function (diffUrl) {
      return $http({
        method: 'GET',
        url: diffUrl
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the metadata export url
     *
     * @param {Number} id - The id of the row in metadata_compare_results
     * @param {Number} fileType - The type of the file enum. Either left or right.
     * @param {String} sfOrgIdForKey - The sfOrg id to use when generating s3 key.
     * @returns {Promise} - A promise that resolves to an object containing the pre-signed url
     */
    var getMetadataExportUrl = function (id, fileType, sfOrgIdForKey) {
      return $http({
        method: 'GET',
        url: 'api/metadata-compare/export-url',
        params: {
          id: id,
          fileType: fileType,
          sfOrgIdForKey: sfOrgIdForKey
        }
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getMetadataCompareFilesByType: getMetadataCompareFilesByType,
      getMetadataDiff: getMetadataDiff,
      getMetadataExportUrl: getMetadataExportUrl
    };
  });
